<template>
  <PageContentLayoutOnly headerColor="#fafafa">
    <div class="notification headerColor">
      <div v-show="false" class="pb-3" v-if="hasReadonly === false">
        <button @click.prevent="refresh" :disabled="loading" class="button is-primary is-rounded">
          Validate
        </button>
      </div>
      <div class="box is-12">
        <div v-if="hasReadonly === false" class="subtitle force-center pt-5">
          Please review your communication to ensure accuracy before sending.
        </div>
        <div v-else-if="hasReadonly === true" class="subtitle force-center pt-5">
          {{ `This communication has been sent on: ${this.formattedSentDate}.` }}
        </div>
        <div v-if="communication" style="overflow: hidden;">
          <div class="subtitle columns">
            <div class="pb-4 column is-4">
              <div class="columns">
                <div class="column is-9"><label class="label">Delivery Methods</label></div>
              </div>
              <div class="pb-3">
                <div>Description</div>
                <div
                  class="small-text"
                  v-if="communicationDescription !== undefined && communicationDescription"
                >
                  {{ communicationDescription }}
                </div>
                <div class="small-red-text" v-else>Warning: Description is needed</div>
              </div>
              <div class="pb-3" v-if="mailingType === 'Mail' || supportMailDelivery">
                <div>Postal Mail Service</div>
                <div
                  class="small-text"
                  v-if="communication.compositionMethod === 'html'"
                  v-html="mailMessage"
                ></div>
                <div
                  class="small-text"
                  v-else-if="communication.compositionMethod === 'pdf-document'"
                >
                  {{
                    `${
                      (pdfFileName !== undefined && pdfFileName) || this.file
                        ? pdfFileName || this.file.name
                        : 'Uploaded file'
                    }`
                  }}
                </div>
                <div class="small-red-text" v-else>
                  Warning: Content or an uploaded file is required.
                </div>
                <div class="small-text" v-if="isLegalCommunication === true">
                  Legal Communication
                </div>
              </div>
              <div class="pb-3" v-if="supportEmailDelivery || communication.supportEmailDelivery">
                <div>Email</div>
                <div
                  class="small-text font-bold"
                  v-if="emailMessageSubject !== undefined && emailMessageSubject"
                >
                  {{ emailMessageSubject }}
                </div>
                <div
                  class="small-text"
                  v-if="emailMessage !== undefined && emailMessage"
                  v-html="emailMessage"
                ></div>
                <div class="small-red-text" v-else>Warning: Content is needed</div>
              </div>
              <div class="pb-3" v-if="supportSMSDelivery || communication.supportSmsDelivery">
                <div>SMS</div>
                <div class="small-text font-bold" v-if="smsSubject !== undefined && smsSubject">
                  {{ smsSubject }}
                </div>
                <div
                  class="small-text"
                  v-if="smsMessage !== undefined && smsMessage"
                  v-html="smsMessage"
                ></div>
                <div class="small-red-text" v-else>Warning: Content is needed</div>
              </div>
            </div>
            <div class="pb-5 column is-4">
              <div class="columns">
                <div class="column is-9"><label class="label">Scheduling</label></div>
              </div>
              <div v-if="deliveryDate">
                <div>Deliver On:</div>
                <div class="small-text">{{ `${formattedDate} ${abbreviatedTimezone || ''}` }}</div>
              </div>
              <div v-else>Deliver Immediately</div>
            </div>
            <div class="pb-5 column is-4">
              <div class="columns">
                <div class="column is-9"><label class="label">Target Audiences</label></div>
              </div>
              <div
                v-if="
                  selectedDeliveryOwners !== undefined &&
                    selectedDeliveryOwners &&
                    selectedDeliveryOwnerIDs !== undefined &&
                    selectedDeliveryOwnerIDs &&
                    selectedDeliveryOwnerIDs.length === 0
                "
              >
                All Owners
              </div>
              <div
                v-if="
                  selectedDeliveryOwnerIDs !== undefined &&
                    selectedDeliveryOwnerIDs &&
                    selectedDeliveryOwnerIDs.length > 0
                "
              >
                <div>Selected Owners</div>
                <div class="small-text" v-if="selectedDeliveryOwners">
                  <div v-if="selectedDeliveryOwners === 'all-owners'">
                    {{ `Delivering to all homeowners` }}
                  </div>
                  <div v-else>
                    {{ `Delivering to ${selectedDeliveryOwnerIDs.length || 0} homeowners` }}
                  </div>
                </div>
                <div class="small-red-text" v-else>Warning: Content is needed</div>
              </div>
            </div>
          </div>
          <div>
            <label
              v-if="
                processedCommunications &&
                  processedCommunications.results &&
                  processedCommunications.numberQueued !== undefined &&
                  processedCommunications.numberQueued &&
                  processedCommunications.numberQueued > 0
              "
              class="label"
              >Processing of Communication</label
            >
            <div class="small-text pb-5" v-if="processedCommunications.results">
              <div class="font-bold">
                {{ `Total Communications: ${processedCommunications.numberQueued}` }}
              </div>
              <div class="font-bold">
                {{ `Total Successfully Sent: ${processedCommunications.numberSuccessful}` }}
              </div>
              <div class="font-bold">
                {{ `Total Failed: ${processedCommunications.numberFailed}` }}
              </div>
              <div v-if="processedCommunications.numberMailedQueued > 0">
                <div class="font-larger2 pt-2">{{ `Postal Mail Service` }}</div>
                <div class="font-bold">
                  {{ `Total Postal Communications: ${processedCommunications.numberMailedQueued}` }}
                </div>
                <div class="font-bold">
                  {{ `Total Postal Mail Sent: ${processedCommunications.numberMailedSuccessful}` }}
                </div>
                <div class="font-bold pb-2">
                  {{ `Total Postal Failed: ${processedCommunications.numberMailedFailed}` }}
                </div>
                <div class="" v-for="(item, index) in processedCommunications.results" :key="index">
                  <div v-if="item.deliveryMethod === 'mail'">
                    <div v-if="item.deliveryResult === 'failure'">
                      {{ `${item.recipientName}: ${item.message}` }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="processedCommunications.numberEmailedQueued > 0">
                <div class="font-larger2 pt-2">{{ `Email Service` }}</div>
                <div class="font-bold">
                  {{ `Total Email Communications: ${processedCommunications.numberEmailedQueued}` }}
                </div>
                <div class="font-bold">
                  {{ `Total Email Sent: ${processedCommunications.numberEmailedSuccessful}` }}
                </div>
                <div class="font-bold pb-2">
                  {{ `Total Email Failed: ${processedCommunications.numberEmailedFailed}` }}
                </div>
                <div
                  class=""
                  v-for="(item2, index2) in processedCommunications.results"
                  :key="index2"
                >
                  <div v-if="item2.deliveryMethod === 'email'">
                    <div v-if="item2.deliveryResult === 'failure'">
                      {{ `${item2.recipientName}: ${item2.message}` }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="processedCommunications.numberTextedQueued">
                <div class="font-larger2 pt-2">{{ `Mobile Service` }}</div>
                <div class="font-bold">
                  {{
                    `Total Text Message Communications: ${processedCommunications.numberTextedQueued}`
                  }}
                </div>
                <div class="font-bold">
                  {{ `Total Texts Sent: ${processedCommunications.numberTextedSuccessful}` }}
                </div>
                <div class="font-bold pb-2">
                  {{ `Total Texts Failed: ${processedCommunications.numberTextedFailed}` }}
                </div>
                <div
                  class=""
                  v-for="(item3, index3) in processedCommunications.results"
                  :key="index3"
                >
                  <div v-if="item3.deliveryResult === 'failure'">
                    {{ `${item3.recipientName}: ${item3.message}` }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pb-5" v-if="validationMessages">
            <label class="label">Validation</label>
            <div class="redcurrency" v-if="validationMessages">{{ validationMessages }}</div>
          </div>
          <div v-if="notValid === false">
            <label class="label font-larger3">{{ costEstimateLabel }}</label>
            <ModernTable
              :region="region"
              :filters="filters"
              :rows="rows"
              :columns="columns"
              height="480px"
              :condensed="true"
              :loading="loading"
              headerColor="#FFF"
            >
              <template v-slot:header>
                <div :style="{ width: '100%', height: '60px' }">
                  <b-button
                    type="is-ghost"
                    @click="filters.show = !filters.show"
                    :style="{ float: 'right', background: 'none', border: 0 }"
                    :class="'filter-button ' + (filters.show ? 'active' : '')"
                  >
                    <b-icon
                      pack="mdi"
                      icon="filter-outline"
                      size="is-small"
                      style="display: inline-block"
                    >
                    </b-icon>
                    <div style="display: inline-block">Filter</div>
                  </b-button>
                </div>
              </template>
            </ModernTable>
          </div>
          <div class="float-right pr-5 pt-3">
            <div class="font-larger2">Total Delivery Cost</div>
            <div class="subtitle" style="font-weight: normal !important;">
              {{ `${grandTotal || 0}` | currency }}
            </div>
          </div>
          <div v-if="deliveryDate" class="pt-3">
            <b-button
              class="is-primary"
              @click.prevent="saveThenSendCommunication"
              :disabled="hasReadonly === true || isSent === true || notValid === true"
              >{{ `${'Confirm & Schedule'}` }}</b-button
            >
            <span class="pl-3">&nbsp;</span>
          </div>
          <div v-else class="pt-3">
            <b-button
              class="is-primary"
              @click.prevent="saveThenSendCommunication"
              :disabled="hasReadonly === true || isSent === true || notValid === true"
              >{{ `${'Confirm & Deliver'}` }}</b-button
            >
            <span class="pl-3">&nbsp;</span>
          </div>
        </div>
      </div>
    </div>
  </PageContentLayoutOnly>
</template>

<script>
import { mailingCommunicationStore } from '@/services/MailingCommunications/store'
import { mapState, mapGetters } from 'vuex'
import { notifyMessage, notifyError, notifyWarning } from '@/services/notify'
import { hoaUtility } from '@/services/Hoa/store'
import moment from 'moment'
import ModernTable from '@/components/tables/Modern/Table'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'

export default {
  name: 'Review',

  components: {
    PageContentLayoutOnly,
    ModernTable
  },

  data() {
    return {
      communication: null,
      communicationID: 0,
      originalCommunicationID: 0,
      formattedDate: '',
      formattedSentDate: '',
      validationMessages: '',
      prevValidationMessages: '',
      processedCommunications: [],
      costEstimates: [],
      isSent: false,
      loading: false,
      costEstimateLabel: 'Cost Estimates',
      grandTotal: 0,
      notValid: false,
      abbreviatedTimezone: '',
      isReadOnly: false,
      documentFile: null,
      imageContent: null,
      base64pdf: null,
      file: null,
      currentTime: new Date(),
      intervalId: null,
      prevTimeCounter: 0,

      filters: {
        show: false
      },

      region: {},

      rows: [],

      columns: [
        {
          field: 'lineItem',
          label: 'Line Item',
          aria: 'Line Item',
          width: '40%',
          sortable: true,
          searchable: true
        },
        {
          field: 'quantity',
          label: 'Quantity',
          aria: 'Quantity',
          width: '20%',
          sortable: true,
          searchable: true
        },
        {
          field: 'cost',
          label: 'Cost\n(per item)',
          aria: 'Cost\n(per item)',
          width: '20%',
          sortable: true,
          searchable: true
        },
        {
          field: 'total',
          label: 'Total',
          aria: 'Total',
          width: '20%',
          sortable: true,
          searchable: true
        }
      ]
    }
  },

  watch: {
    hoaId() {
      this.processStateChangeForWatch()
    },
    formattedTime() {
      console.debug('formatted time watched...')

      this.prevTimeCounter++

      if (this.hasReadonly !== true) {
        if (this.prevTimeCounter >= 10) {
          this.checkForNewChanges()
          this.prevTimeCounter = 0
        }
      }
    }
  },

  methods: {
    determineRows() {
      console.debug('in determineRows()...')
      const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      })

      if (this.costEstimates !== undefined && this.costEstimates) {
        Array.from(this.costEstimates).forEach(f => {
          if (f && f.quantity > 0) {
            const estimate = {
              lineItem: f.lineItemName,
              quantity: f.quantity,
              cost: currencyFormatter.format(f.costPerItem),
              total: currencyFormatter.format(f.lineTotal)
            }

            if (estimate) {
              this.rows.push(estimate)
            }
          }
        })
      }
    },

    async getDocument() {
      try {
        const params = {
          communicationID: this.mailingCommunicationID
            ? this.mailingCommunicationID
            : this.communicationID,
          asBase64: true
        }

        await mailingCommunicationStore
          .dispatch('getCommunicationDocumentGetFile', {
            params: params
          })
          .then(({ returned }) => {
            if (returned) {
              this.documentFile = returned
            }

            if (this.isDebug == true)
              console.debug(
                ' - params' + JSON.stringify(params) + ' - this.documentFile=' + returned
              )
            if (this.documentFile && this.documentFile != undefined) {
              if (this.isDebug == true)
                console.debug('image or pdf............this.searchTerm:' + this.documentFile)

              this.base64pdf = this.documentFile
              this.imageContent = null

              console.debug('converting base64 to file object..............')
              if (this.documentFile) {
                console.debug('converting base64 to file object..............')
                const mimeType = (this.documentFile.match(/^data:([^;]+);/) || '')[1]
                const returnedFile = this.dataURLtoFile(
                  this.documentFile,
                  `request-file.${mimeType.replace('image/', '')}`
                )

                if (returnedFile) {
                  console.debug('converting base64 to file object..............')
                  this.file = returnedFile
                  this.$store
                    .dispatch('communication/selectedUploadFile', {
                      uploadFile: this.file
                    })
                    .then(() => {
                      this.$store
                        .dispatch('communication/savePdfFileName', {
                          pdfFileName: this.file.name
                        })
                        .then(() => {
                          console.debug('converting base64 to file object..............')
                        })
                    })
                }
              }
            }
          })
      } catch (e) {
        if (this.isDebug == true) console.debug(e)
      }
    },

    async loadCurrentCommunication() {
      try {
        this.validationMessages = ''
        console.debug('loadCurrentCommunication=' + JSON.stringify(this.communication))
        if (
          (this.mailingCommunicationID !== undefined && this.mailingCommunicationID) ||
          (this.communicationID !== undefined && this.communicationID)
        ) {
          await mailingCommunicationStore
            .dispatch('getCommunicationById', {
              communicationID: this.mailingCommunicationID
                ? this.mailingCommunicationID
                : this.communicationID
            })
            .then(async ({ result }) => {
              if (result) {
                this.communication = result

                this.$store.dispatch('communication/saveDeliveryDate', {
                  deliveryDate: this.communication.deliveryDate
                })

                this.$store.dispatch('communication/saveCompositionMethod', {
                  compositionMethod: this.communication.compositionMethod
                })

                this.$store.dispatch('communication/composedMailMessage', {
                  mailMessage: this.communication.htmlContent
                })

                this.$store.dispatch('communication/composedEmailMessage', {
                  emailMessage: this.communication.htmlEmailContent
                })

                this.$store.dispatch('communication/composedEmailSubject', {
                  emailMessageSubject: this.communication.emailSubject
                })

                this.$store.dispatch('communication/composedSmsMessage', {
                  smsMessage: this.communication.htmlSmsContent
                })

                this.$store.dispatch('communication/saveSmsSubject', {
                  smsSubject: this.communication.smsSubject
                })

                if (this.deliveryDate !== undefined && this.deliveryDate) {
                  this.formattedDate = moment(new Date(this.deliveryDate).toISOString()).format(
                    'LLL'
                  )
                }

                if (this.communication.sentDate !== undefined && this.communication.sentDate) {
                  this.formattedSentDate = moment(
                    new Date(this.communication.sentDate).toISOString()
                  ).format('LLL')
                }

                await this.loadCommunicationCostEstimates()
                if (this.communication.sentDate !== undefined && this.communication.sentDate) {
                  this.costEstimateLabel = 'Submitted Costs'
                }
              }
            })
        }
      } catch (e) {
        console.debug('There was a review error in loadCurrentComunication: ' + e)
      }
    },

    async loadCommunicationCostEstimates() {
      console.debug('in loadCommunicationCostEstimates()...')

      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2
      })

      if (
        this.mailingCommunicationID ||
        (this.communicationID !== undefined && this.communicationID)
      ) {
        this.rows = []
        this.costEstimates = []

        try {
          console.debug('in loadCommunicationCostEstimates before store()...')
          await mailingCommunicationStore
            .dispatch('getCommunicationCostEstimateList', {
              communicationID: this.mailingCommunicationID
                ? this.mailingCommunicationID
                : this.communicationID
            })
            .then(({ list, results, grandTotal, message }) => {
              if (list) {
                console.debug('in loadCommunicationCostEstimates in list...' + JSON.stringify(list))

                this.costEstimates = list
                this.grandTotal = formatter.format(grandTotal || 0)
                this.notValid = false
              }

              if (message) {
                const valMessage = (message + '').replace('Error:', '').replace(';', '')
                this.validationMessages = valMessage.replace(';', '')
                this.notValid = true
                return
              }

              console.debug('results=' + JSON.stringify(results))

              if (results) {
                this.processedCommunications = results
                console.debug(
                  'processedCommunications.numberQueued' + this.processedCommunications.numberQueued
                )
              }
            })
        } catch (e) {
          console.debug('loadCommunicationCostEstimates error: ' + e)
        }
      }

      loadingComponent.close()
    },

    async finalizeMessageFromState(showMessage) {
      if (this.hasReadonly === false) {
        const loadingComponent = this.$buefy.loading.open({
          container: null
        })

        try {
          this.composedText = this.mailMessage

          if (this.mailingCommunicationID !== undefined && this.mailingCommunicationID) {
            const params = {
              communicationID: this.mailingCommunicationID,
              supportMailDelivery: this.mailingType === 'Mail',
              supportEmailDelivery: this.mailingType === 'Email',
              supportSMSDelivery: this.mailingType === 'SMS',
              isLegalCommunication: this.isLegalCommunication,
              htmlContent:
                this.pdfFileName !== undefined && this.pdfFileName ? '' : this.composedText || '',
              documentID:
                this.pdfFileName !== undefined && this.pdfFileName ? this.documentID : null,
              compositionMethod:
                this.pdfFileName !== undefined && this.pdfFileName ? 'pdf-document' : 'html',
              mailFullDuplex: this.isFullDuplex,
              mailColor: this.isColor,
              description: this.communicationDescription,
              mailingTypeID: this.mailingTypeID,
              selectedDeliveryOwnerIDs: this.selectedDeliveryOwnerIDs,
              selectedDeliveryOwners: this.selectedDeliveryOwners,
              deliveryDate: this.deliveryDate,
              isFullDuplex: this.isFullDuplex,
              htmlSmsContent: this.composedText,
              smsSubject: this.composedSubject,
              isColor: this.isColor
            }

            console.debug('mail params=' + JSON.stringify(params))

            await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
              params,
              done: async ({ detail }) => {
                if (detail) {
                  console.debug('update communication=' + JSON.stringify(detail))

                  this.communicationID = detail.communicationID

                  if (showMessage !== undefined && showMessage && showMessage === true) {
                    notifyMessage('This message has been saved for sending.')
                  }
                }
              }
            })
          }
        } catch (error) {
          console.debug('error=' + error.message)
          loadingComponent.close()
        }

        loadingComponent.close()
      }
    },

    async saveThenSendCommunication() {
      console.debug('saveThenSendCommunication()...')
      await this.finalizeMessageFromState(false)
      console.debug('sendCommunication()...')
      if (this.deliveryDate !== undefined && this.deliveryDate) {
        notifyWarning(
          `This communication will be processed at a future date: ${this.formattedDate}`
        )
      } else {
        await this.sendCommunication()
      }
    },

    async sendCommunication() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      if (this.grandTotal && this.grandTotal === 0) {
        notifyError(
          'A cost estimate must be present prior to submitting this communication. Please make sure each step has been properly entered.'
        )
        return
      }

      try {
        this.validationMessages = ''
        if (
          (this.mailingCommunicationID !== undefined && this.mailingCommunicationID) ||
          (this.communicationID !== undefined && this.communicationID)
        ) {
          await mailingCommunicationStore.dispatch('sendCommunication', {
            communicationID: this.mailingCommunicationID
              ? this.mailingCommunicationID
              : this.communicationID,
            done: async ({ list, message }) => {
              if (list && list.results) {
                if (list.results.length > 0) {
                  this.processedCommunications = list
                  this.costEstimateLabel = 'Submitted Costs'
                }

                if (list.costEstimates) {
                  this.costEstimates = []
                  this.rows = []
                  this.costEstimates = list.costEstimates
                  this.determineRows()
                }

                var formatter = new Intl.NumberFormat('en-US', {
                  style: 'decimal',
                  minimumFractionDigits: 2
                })

                this.grandTotal = formatter.format(list.grandTotalCostEstimate || 0)
              }

              if (message) {
                const valMessage = (message + '').replace('Error:', '').replace(';', '')
                this.validationMessages = valMessage.replace(';', '')
                return
              }

              notifyMessage('This communication was successfully sent.')
              this.isSent = true
              this.isReadOnly = true
              await this.refresh()
            }
          })
        }
      } catch (e) {
        console.debug('error messages=' + e.message)
        loadingComponent.close()
      }

      loadingComponent.close()
    },

    async refresh() {
      console.debug('in refresh...')

      this.processStateChangeForWatch().then(() => {
        if (this.originalCommunicationID > 0) {
          this.$router.go(0)
        }

        if (this.isSent === true || this.hasReadonly === true) {
          this.$router.push({
            path: `/communicationtabs/${
              this.mailingCommunicationID ? this.mailingCommunicationID : this.communicationID
            }/communicationReview#tab`,
            query: { readonly: true }
          })

          this.$store.dispatch('communication/saveHasReadonly', {
            hasReadonly: true
          })
        } else {
          this.$router.push({
            path: `/communicationtabs/${
              this.mailingCommunicationID ? this.mailingCommunicationID : this.communicationID
            }/communicationReview#tab`,
            query: { readonly: false }
          })

          this.$store.dispatch('communication/saveHasReadonly', {
            hasReadonly: false
          })
        }

        notifyMessage('This page has been loaded with the latest saved data.')
      })
    },

    async loadHoaTimezone() {
      await hoaUtility
        .dispatch('getHoaById', {
          hoaID: this.hoaId && this.hoaId > 0 ? this.hoaId : 0
        })
        .then(({ result }) => {
          if (result) {
            if (result.timezoneName) {
              this.myTimezone = result.timezoneName
            } else {
              this.myTimezone = 'Not Setup'
            }
          }
        })

      this.$store.dispatch('communication/saveTimezone', {
        timezone: this.myTimezone
      })
    },

    abbreviateTimezone() {
      if (!this.timezone) {
        this.loadHoaTimezone()
      }

      this.abbreviatedTimezone = ''

      if (this.timezone !== undefined && this.timezone) {
        const words = this.timezone ? this.timezone.split(' ') : ''

        for (let i = 0; i < words.length; i++) {
          this.abbreviatedTimezone = this.abbreviatedTimezone + words[i][0].toUpperCase()

          if (this.abbreviatedTimezone && this.abbreviatedTimezone.length > 3) {
            this.abbreviatedTimezone.substring(0, 2)
          }
        }
      }
    },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },

    async checkForNewChanges() {
      this.$store.dispatch('communication/saveIsEdit', {
        isEdit: false
      })
      await this.processStateChangeForWatch()
    },

    async processStateChangeForWatch() {
      //if (this.communication.compositionMethod !== undefined && this.communication.compositionMethod === 'pdf-document') {
      //  await this.getDocument()
      //}

      await this.loadCurrentCommunication().then(() => {
        this.determineRows()

        this.abbreviateTimezone()
      })
    }
  },
  async mounted() {
    this.communicationID = this.$route.params.id || 0
    this.originalCommunicationID = this.$route.params.id || 0

    if (this.$route.query.readonly !== undefined) {
      this.isReadOnly = this.$route.query.readonly || false
    }

    this.intervalId = setInterval(() => {
      this.currentTime = new Date()
    }, 1000)

    console.debug('redirected communicationID=' + JSON.stringify(this.$route.params.id))

    await this.processStateChangeForWatch()
  },

  beforeUnmount() {
    // Or unmounted() for Vue 3
    clearInterval(this.intervalId)
  },

  computed: {
    formattedTime() {
      const hours = this.currentTime
        .getHours()
        .toString()
        .padStart(2, '0')
      const minutes = this.currentTime
        .getMinutes()
        .toString()
        .padStart(2, '0')
      const seconds = this.currentTime
        .getSeconds()
        .toString()
        .padStart(2, '0')
      return `${hours}:${minutes}:${seconds}`
    },
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('communication', [
        'timezone',
        'supportMailDelivery',
        'supportEmailDelivery',
        'supportSMSDelivery',
        'isLegalCommunication',
        'mailingTypeID',
        'mailingType',
        'mailMessage',
        'emailMessage',
        'emailMessageSubject',
        'pdfFileName',
        'mailingCommunicationID',
        'communicationDescription',
        'selectedDeliveryOwnerIDs',
        'selectedDeliveryOwners',
        'deliveryDate',
        'isFullDuplex',
        'isColor',
        'smsMessage',
        'smsSubject',
        'compositionMethod',
        'hasReadonly',
        'isEdit'
      ])
    })
  }
}
</script>
